import React, { useEffect, useRef, useState } from "react";
import { CircularIndeterminate, FormButton } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { RNHComponenteSecundarioGet } from "services/services-mia/RNHComponenteSecundarioGet";
import { RNHComponenteSecundarioDel } from "services/services-mia/RNHComponenteSecundarioDel";

export default function DeleteModal({ user, updateList, closeModal, setterRowSelected }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState();
    const formikRef = useRef();

    const getComponenteSecundarioData = async () => {
        setIsLoading(true);
        const result = await RNHComponenteSecundarioGet(credentials, { id: user.id })
        formikRef.current.setValues({
            id: result[0].rnhComponenteSecundarioId,
            nombre: result[0].rnhComponenteSecundarioNombre,
        });
        setData(result[0]);
        setIsLoading(false);
    }
    
    const handleDeleteComponente = async (values) => {
        const response = await RNHComponenteSecundarioDel(
            credentials,
            { id: data.rnhComponenteSecundarioId }
        );
        if (response.length === 0) {
            setSnackBarInfo({
                message: "Componente eliminado correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            setterRowSelected({ status: false, row: {} })
            closeModal();
        }
    }

    useEffect(() => {
        getComponenteSecundarioData()
    }, []);
    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                nombre: "",
            }}
            validationSchema={
                yup.object({
                    nombre: yup.string("Debe ingresar un nombre").max(45, "Debe tener menos de 45 caracteres").required("Debe ingresar un nombre"),
                })
            }
            onSubmit={(values) => {
                handleDeleteComponente(values);
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <>
                        <FormikTextInput
                            fullWidth={true}
                            name="nombre"
                            placeholder=""
                            labelText="Nombre de Componente"
                            disabled={true}
                        />
                    </>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Eliminar" }}
                        onCloseModal={closeModal}
                    />
                    {(inRequest) && <CircularIndeterminate />}
                </div>
            </Form>
        </Formik>
    );
}
